import React, { useState } from "react";
import {
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ArtistsWishlistTableDropdown = ({
  data,
  setDeleteID,
  setToggleModal,
  setDataModal
}) => {
  const { t } = useTranslation();
  const currentRoute = useLocation().pathname;
  const [dropdownOpen, setOpen] = useState(false);
  const toggle = () => setOpen(!dropdownOpen);
  const addArtistLink = `${currentRoute}/${data.id}/add-artist/`;

  return (
    <ButtonDropdown isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle caret outline color="primary">
        {t("artistsWishlist.view.table.dropdown.action")}
      </DropdownToggle>
        <DropdownMenu>
          <DropdownItem
            style={{ cursor: "pointer" }}
          >
            <Link to={addArtistLink}>{t("artistsWishlist.view.table.dropdown.addAsArtist")}</Link>
          </DropdownItem>
          <DropdownItem
            onClick={() => {
              setDataModal(data);
              setDeleteID(data.id);
              setToggleModal(true);
            }}
            style={{ cursor: "pointer" }}
          >
            {t("artistsWishlist.view.table.dropdown.delete")}
          </DropdownItem>
      </DropdownMenu>
    </ButtonDropdown>
  );
};

export default ArtistsWishlistTableDropdown;
